module.exports = __webpack_public_path__ + "img/allow-green-up.6528bd56.svg";